import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/messages',
    name: 'Messages',
    component: () => import('../views/Messages.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/records',
    name: 'Records',
    component: () => import('../views/Records.vue')
  },
  {
    path: '/online-learning',
    name: 'OnlineLearning',
    component: () => import('../views/OnlineLearning.vue')
  },
  {
    path: '/learning-progress',
    name: 'LearningProgress',
    component: () => import('../views/LearningProgress.vue')
  },
  {
    path: '/word-book',
    name: 'WordBook',
    component: () => import('../views/WordBook.vue')
  },
  {
    path: '/duration',
    name: 'Duration',
    component: () => import('../views/Duration.vue')
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('../views/ChangePassword.vue')
  },
  {
    path: '/units-all-vocabularys/:unitId',
    name: 'UnitsAllVocabularys',
    component: () => import('../views/UnitsAllVocabularys.vue')
  },
  {
    path: '/practice-system',
    name: 'PracticeSystem',
    component: () => import('../views/PracticeSystem.vue')
  },
  {
    path: '/reading-comprehension-vocabulary/:unitId',
    name: 'ReadingComprehensionVocabulary',
    component: () => import('../views/ReadingComprehensionVocabulary.vue')
  },
  {
    path: '/unit-test-practice/:unitId',
    name: 'UnitTestPractice',
    component: () => import('../views/UnitTestPractice.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
  })
}

export default router
